// fix https://github.com/primefaces/primevue/issues/6616

import { Popover } from "primevue";
import { $dt } from '@primeuix/styled';
import { addClass, getOffset } from '@primeuix/utils/dom';
import { computePosition, flip, offset, shift } from "@floating-ui/dom";


// @ts-expect-error
const alignOverlay = Popover.methods["alignOverlay"] as () => void;
// @ts-expect-error
Popover.methods["alignOverlay"] = async function() {
  if (this.appendTo !== "body") {
    if (this.container === null || this.target == null) { return; }

    const {y: top, x: left, placement} = await computePosition(this.target, this.container, {
      placement: "bottom",
      middleware: [
        flip(),
        shift({ mainAxis: true, crossAxis: true }),
        offset(8),
      ],
    });

    this.container.style.top = `${top}px`;
    this.container.style.left = `${left}px`;
    this.container.style.transformOrigin = placement;


    const containerOffset = getOffset(this.container);
    const targetOffset = getOffset(this.target);
    let arrowLeft = 0;

    if (containerOffset.left < targetOffset.left) {
      arrowLeft = (targetOffset.left as number) - (containerOffset.left as number);
    }

    this.container.style.setProperty($dt('popover.arrow.left').name, `${arrowLeft}px`);


    if (placement == "top") {
      this.container.setAttribute("data-p-popover-flipped", "true");
      if (!this.isUnstyled) {
        addClass(this.container, "p-popover-flipped");
      }
    }
  } else {
    alignOverlay.apply(this);
  }
};


// fix number fields not being clearable if they have a initial value set
// affects our lng/lat coordinate fields
// https://github.com/primefaces/primevue/issues/7945
// apply pr https://github.com/primefaces/primevue/pull/8367

import BaseEditableHolder from "@primevue/core/baseeditableholder";

(BaseEditableHolder as any).watch["$formDefaultValue"].handler = function(newValue: any) {
  if (this.d_value === undefined && newValue !== undefined) {
    this.d_value = newValue;
  }
};

(BaseEditableHolder as any).computed["$formValue"] = function() {
  const formState = this.$pcForm?.getFieldState(this.$formName);
  return formState ? formState.value : this.$pcFormField?.$field?.value;
}
